export default "__VITE_ASSET__c9431a86__"